/**
 * Created by Carsten Bühler
 * User: CBuehler on 05.09.2016
 * Copyright: xdot GmbH 2015
 */
'use strict';


import L from 'external/leaflet';
import './ResizableControl.scss';

L.Control.ResizableControl = L.Control.extend({
    options: {
        position: 'topleft'
    },

    initialize(options) {
        this.active = false;
        L.Util.setOptions(this, options);
    },

    onAdd(map) {
        const { title, iconLeft } = this.options;
        this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom resizable-control-button');
        this.header = L.DomUtil.create('div', 'resizable-control-button-header', this.container);

        if(iconLeft) {
             L.DomUtil.create('span', `icon-left ${iconLeft}`, this.header);
        }
        this.title = L.DomUtil.create('span', '', this.header);
        this.title.innerHTML = title;
        this.icon = L.DomUtil.create('span', 'fa fa-expand ml-2', this.header);

        this.container.setAttribute('title', title);
        this.container.setAttribute('role', 'button');

        this.contentContainer = L.DomUtil.create('div', 'resizable-control-content', this.container);

        L.DomEvent.on(this.container, 'click', this.toggle, this);

        return this.container;
    },

    onRemove(map) {
        L.DomEvent.off(this.header);
        this.icon = null;
        this.contentContainer = null;
        this.header = null;
        this.container = null;
    },

    toggle(e) {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        this.container.classList.toggle('active');
        this.active = !this.active;
        if(this.active) {
            this.icon.classList.remove('fa-expand');
            this.icon.classList.add('fa-compress');
            this.options.onOpen?this.options.onOpen():null;
        } else {
            this.icon.classList.remove('fa-compress');
            this.icon.classList.add('fa-expand');
            this.options.onClose?this.options.onClose():null;
        }
    },

    setContent(content) {
        while (this.contentContainer.firstChild) {
            this.contentContainer.removeChild(this.contentContainer.firstChild);
        }
        this.contentContainer.appendChild(content);
    }
});

export default L.control.resizableControl = function(opts) {
    return new L.Control.ResizableControl(opts);
};



// WEBPACK FOOTER //
// ./js/plugins/ResizableControl/ResizableControl.js